var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient_arrow-image"},[_c('div',{staticClass:"gradient_arrow-inner_text"},[_vm._v("\n    "+_vm._s(_vm.separatorTitle)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }